import React from 'react';
import {BrowserRouter, Route, Switch} from 'react-router-dom';
import App from '../App';
//import NotFoundPage from '../Components/NotFoundPage';



const AppRouter = () => (
    <BrowserRouter>
        <Switch>
            <Route path="/" component={App} exact={true} />

        </Switch>
    </BrowserRouter>
);

export default  AppRouter;


// WEBPACK FOOTER //
// ./src/Routers/AppRouter.js